module.exports = __webpack_public_path__ + "static/media/invite_banner.7660856c.png";